import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

const CSRF_COOKIE = 'XSRF-TOKEN';
const CSRF_HEADER = 'X-XSRF-TOKEN';
const MUTANT_METHODS = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);

/**
 * Lee el valor de una cookie por nombre.
 * Retorna null si la cookie does not exist.
 */
function getCookie(name: string): string | null {
  const match = document.cookie
    .split(';')
    .map(c => c.trim())
    .find(c => c.startsWith(`${name}=`));
  return match ? decodeURIComponent(match.split('=')[1]) : null;
}

/**
 * csrfInterceptor
 *
 * Interceptor funcional que agrega el header `X-XSRF-TOKEN` a las peticiones
 * mutantes (POST, PUT, PATCH, DELETE) dirigidas a la API del proyecto.
 *
 * El token se lee desde la cookie `XSRF-TOKEN` que el servidor debe establecer.
 * Las peticiones GET, HEAD y OPTIONS, asi como las de dominios externos,
 * no incluyen el header para evitar exposicion innecesaria del token.
 */
export const csrfInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const isMutant = MUTANT_METHODS.has(req.method);
  const isSameOrigin = req.url.startsWith(environment.apiUrl);

  if (!isMutant || !isSameOrigin) {
    return next(req);
  }

  const token = getCookie(CSRF_COOKIE);
  if (!token) {
    return next(req);
  }

  const secureReq = req.clone({ setHeaders: { [CSRF_HEADER]: token } });
  return next(secureReq).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 403 && err.error?.error === 'CSRF_INVALID') {
        return throwError(() => new Error('CSRF validation failed'));
      }
      return throwError(() => err);
    })
  );
};
